import { render, staticRenderFns } from "./resetPasswordModule.vue?vue&type=template&id=2954cfe4&scoped=true"
import script from "./resetPasswordModule.vue?vue&type=script&lang=js"
export * from "./resetPasswordModule.vue?vue&type=script&lang=js"
import style0 from "./resetPasswordModule.vue?vue&type=style&index=0&id=2954cfe4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2954cfe4",
  null
  
)

export default component.exports